import { render, staticRenderFns } from "./media.vue?vue&type=template&id=5a685800&scoped=true&"
import script from "./media.vue?vue&type=script&lang=js&"
export * from "./media.vue?vue&type=script&lang=js&"
import style1 from "./media.vue?vue&type=style&index=1&id=5a685800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a685800",
  null
  
)

export default component.exports